<template>
  <div>
    <Banner
      v-if="
        (subscriptionStatus === SUBSCRIBED_CUSTOMER_STATUS ||
          subscriptionStatus === TRIAL_CUSTOMER_STATUS) &&
        ($slots.title || $slots.content || $slots.button)
      "
      :image-url="imageUrl"
      :desktop-image-url="desktopImageUrl"
      :fade-appearance="fadeAppearance"
    >
      <template #date>
        <slot name="date" />
      </template>

      <template #title>
        <slot name="title" />
      </template>

      <template #content>
        <slot name="content" />
      </template>

      <template #button>
        <slot name="button" />
      </template>

      <template #cgv>
        <slot name="cgv" />
      </template>
    </Banner>

    <Banner
      v-else-if="subscriptionStatus === UNPAID_CUSTOMER_STATUS"
      image-url="https://japhy-assets.twic.pics/download?id=1_SZ3Luf6dVM0kaw5sJAk5in5FUiOQVm_"
      fade-appearance="none"
    >
      <template #title>{{ $i18n('Abonnement bloqué') }}</template>

      <template #content>
        {{
          $i18n(
            'Mettez à jour vos informations de paiement pour réactiver votre abonnement Japhy',
          )
        }}
      </template>

      <template #button>
        <Button @click="$store.dispatch('modal/open', 'creditCardModal')">
          {{ $i18n('Mettre à jour') }}
        </Button>
      </template>
    </Banner>

    <Banner
      v-else-if="subscriptionStatus === UNSUBSCRIBED_CUSTOMER_STATUS"
      image-url="https://japhy-assets.twic.pics/download?id=1_SZ3Luf6dVM0kaw5sJAk5in5FUiOQVm_"
      fade-appearance="none"
    >
      <template #title>{{ $i18n('Abonnement suspendu') }}</template>

      <template #content>
        {{
          $i18n(
            'Cliquez sur se réabonner pour recevoir de nouvelles livraisons',
          )
        }}
      </template>

      <template #button>
        <Button @click="resubscribe">
          {{ $i18n('Je me réabonne') }}
        </Button>
      </template>
    </Banner>

    <CardConfirmationModal />
  </div>
</template>
<script>
import { SUCCESS } from '@front/common/constants'
import { useConfirmationModal } from '@front/common/hooks'
import { Banner } from '@front/ui'
import useAlert from '@front/ui/Alert/useAlert'
import { computed, defineComponent } from '@vue/composition-api'

import useCustomer from '@member-area/core/resources/Customer/Customer.hook'
import {
  SUBSCRIBED_CUSTOMER_STATUS,
  TRIAL_CUSTOMER_STATUS,
  UNPAID_CUSTOMER_STATUS,
  UNSUBSCRIBED_CUSTOMER_STATUS,
} from '@member-area/core/resources/Customer/constants'
import useNextOrders from '@member-area/core/resources/NextOrder/NextOrder.hook'
import usePet from '@member-area/core/resources/Pet/Pet.hook'
import useSubscription from '@member-area/core/resources/Subscription/Subscription.hook'
import CardConfirmationModal from '@member-area/pages/Home/components/Unsubscribed/components/CardConfirmationModal.vue'

export default defineComponent({
  components: { Banner, CardConfirmationModal },
  props: {
    imageUrl: {
      type: String,
      default: '',
    },
    desktopImageUrl: {
      type: String,
      default: '',
    },
    fadeAppearance: {
      type: String,
    },
  },
  setup() {
    const { customer } = useCustomer()
    const { confirm } = useConfirmationModal()
    const { fetchCustomer, resubscribeCustomer } = useCustomer()
    const { fetchSubscription } = useSubscription()
    const { fetchPets } = usePet()
    const { fetchNextOrders } = useNextOrders()
    const { triggerAlert } = useAlert()

    const subscriptionStatus = computed(() => {
      return customer.value.subscriptionStatus
    })

    async function resubscribe() {
      await confirm()
      await resubscribeCustomer()
      await Promise.all([fetchSubscription(), fetchPets(), fetchNextOrders()])
      await fetchCustomer()

      triggerAlert({
        status: SUCCESS,
        message:
          'Votre réabonnement a été effectué avec succès. Bienvenue à nouveau !',
      })
    }

    return {
      subscriptionStatus,
      SUBSCRIBED_CUSTOMER_STATUS,
      TRIAL_CUSTOMER_STATUS,
      UNPAID_CUSTOMER_STATUS,
      UNSUBSCRIBED_CUSTOMER_STATUS,
      resubscribe,
    }
  },
})
</script>
